import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'booleanDisplay',
    standalone: false
})
export class BooleanDisplayPipe implements PipeTransform {
	private translations;

	constructor(private translateService: TranslateService) {
	}

	transform(value: boolean): string {
		this.translateService.get(['common.yes', 'common.no']).
			subscribe(translations => this.translations = translations)

		return value ? this.translations['common.yes'] : this.translations['common.no'];
	}
}
